import { memo } from 'react';
import { NodeProps } from 'reactflow';
import { BaseNode } from './BaseNode';

export const SurveyRatingNode = memo((props: NodeProps) => {
  const getDescription = () => {
    const content = props.data.config?.content || props.data.config?.message;
    if (content) {
      return content.substring(0, 30) + (content.length > 30 ? '...' : '');
    }
    return 'Configure a pergunta de satisfação';
  };

  return (
    <BaseNode
      {...props}
      icon="⭐"
      label="Pesquisa (Rating)"
      color="#f59e0b"
      description={getDescription()}
      onDelete={props.data.onDelete}
    />
  );
});

SurveyRatingNode.displayName = 'SurveyRatingNode';
